import { useSelector } from "react-redux";
import { selectUserData, selectUserToken } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import OptifundDashboard from "../../../../components/AssetManagement/Overview/OptifundDashboard/OptifundDashboard";
import {
  OPTIFUND_SITE_NAME,
  userHasOptifundSiteAccess,
} from "../../../../components/AssetManagement/Overview/OptifundDashboard/optifundSiteAccess";
import { useWebsiteSharedUid } from "../../../../customHooks/useWebsiteSharedUid";

// Two independent gates have to pass: the module-level permission
// (view_optifund_dashboard, under the "overview" capability) and site-level
// access - Optifund data comes from one specific site, so a user without
// access to that site must see the 403 page instead of another site's data.
export default function OptifundDashboardScreen() {
  const userToken = useSelector(selectUserToken);
  const userData = useSelector(selectUserData);
  const hasOptifundDashboardPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "overview",
    "view_optifund_dashboard"
  );
  const hasSiteAccess = userHasOptifundSiteAccess(userData);
  const websiteSharedUid = useWebsiteSharedUid(OPTIFUND_SITE_NAME);

  return hasOptifundDashboardPermission && hasSiteAccess && websiteSharedUid ? (
    <OptifundDashboard userToken={userToken} websiteSharedUid={websiteSharedUid} />
  ) : (
    <Page404 />
  );
}
